import OrganizationInfoCard from "../organizationInfoCard";
import { OrganizationInfo, ParticipantInfo } from "../../types";
import ParticipantInfoCard from "../participantInfoCard";
import ContextEntityType from "shared/enums/ContextEntityType";

export default function InfoCard(props: {
  contextEntityType?: ContextEntityType;
  organizationInfo?: OrganizationInfo;
  participantInfo?: ParticipantInfo;
  profilePictureLocation?: string;
}) {
  switch (props.contextEntityType) {
    case ContextEntityType.PROGRAM_ORGANIZATION:
    case ContextEntityType.EVENT_ORGANIZATION:
      return <OrganizationInfoCard organizationInfo={props.organizationInfo} />;
    case ContextEntityType.PROGRAM_PARTICIPANT:
      return (
        <ParticipantInfoCard
          participantInfo={props.participantInfo}
          profilePictureLocation={props.profilePictureLocation}
        />
      );
    default:
      return null;
  }
}
